import { SuperModel } from './super-model.model';

export class Warehouse extends SuperModel {
  email: string;
  gsped_id: string;
  name: string;
  phone: string;
  warehouse_type: string;
  code: string;

  constructor(data: Partial<Warehouse> = {}) {
    super(data);
  }

  get serialised() {
    return {};
  }
}
